/* ──────────────────────────────────────────────────────────────────────
 *  Environment Configuration
 * ────────────────────────────────────────────────────────────────────── */

export const env = {
  // ─── Auth ──────────────────────────────────────────────────────────
  authLoginUrl:
    import.meta.env.VITE_AUTH_LOGIN_URL || "https://auth.pulsebusiness.ai",

  // ─── Supabase ──────────────────────────────────────────────────────
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || "",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "",

  // ─── Agent Hub ─────────────────────────────────────────────────────
  agentHubUrl:
    import.meta.env.VITE_AGENT_HUB_URL ||
    "https://agent-hub.pulsebusiness.ai",

  // ─── Mock Mode ─────────────────────────────────────────────────────
  mockMode: import.meta.env.VITE_MOCK_MODE === "true",

  // ─── MCP ───────────────────────────────────────────────────────────
  mcpUrl:
    import.meta.env.VITE_MCP_URL ||
    "https://agent-hub.pulsebusiness.ai/mcp",

  // ─── App ───────────────────────────────────────────────────────────
  appUrl:
    import.meta.env.VITE_APP_URL || "https://agents.pulsebusiness.ai",
} as const;

export const isMockMode = (): boolean => {
  return env.mockMode || (!env.supabaseUrl && !env.supabaseAnonKey);
};
